// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"245":"af627148d3aaa1416ff2","396":"a0506171e114a2c17087","642":"39b536cf81fd7aabed04","672":"2f35b503c52c5c4e3c61","757":"a5e0c837adf0160136c3"}[chunkId] + ".js";
};